var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var SystemLevelService = /** @class */ (function (_super) {
            __extends(SystemLevelService, _super);
            function SystemLevelService(injectedBreeze, $q) {
                return _super.call(this, injectedBreeze, $q) || this;
            }
            SystemLevelService.prototype.getSystemLevel = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getMostSystemLevelInfo = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevelsLazy")
                    .expand("variableSchema, myConstants, myClaims, myEmailGroups, myStaticDocuments, myCalculations.valueOperation, myTimeTrackers, myClaimGroups");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelConstants = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myConstants");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelJsonDictionaryStores = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myJsonDictionaryStores");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelMapConfigurations = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myMapConfigurations.layers, myMapConfigurations.defaultLayer");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelObjectQueries = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myObjectQueries.myProjectionObjectSchema.properties.typeSchema.properties, myObjectQueries.myInputObjectSchema.properties");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelSecurityMatrices = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("mySecurityMatrices.claimBindings");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelVariables = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("variableSchema.properties");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelClaims = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myClaims");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelClaimsWithGrantAuthorizations = function () {
                var expand = "myClaims.claimGrantAuthorities.myGrantClaimDefinition, " +
                    "myClaims.claimGrantAuthorities.claimGrantAuthorityValues, " +
                    "myClaims.claimGrantAuthorities.claimGrantRestrictionValues";
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand(expand);
                return this.fetch(query);
            };
            SystemLevelService.prototype.getUserRepositoryConfigurations = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myUserRepositoryConfigurations");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelEmailGroups = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myEmailGroups.myEmailAddresses, myEmailGroups");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemEmailConfigurations = function () {
                var expand = "myEmailConfigurations, " +
                    "myEmailConfigurations.recipients.claim, " +
                    "myEmailConfigurations.carbonCopies, " +
                    "myEmailConfigurations.blindCarbonCopies, " +
                    "myEmailConfigurations.documents";
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand(expand);
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelBatchJobs = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand('myBatchJobConfigurations, myBatchJobConfigurations.parameters, myBatchJobConfigurations.parameters.treeItem');
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelApiConfigurations = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand('myApiConfigurations.parameters');
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelStaticDocuments = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myStaticDocuments");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelCalculations = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myCalculations");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelPaymentInfo = function () {
                var expand = "myPaymentConfigurations.myCustomActionInputs.myTreeItem, " +
                    "myPaymentConfigurations.myPaymentRequestFormValueLookup.myTreeItem, " +
                    "myPaymentConfigurations.myPaymentCustomInformation.valueCalculation, " +
                    "myPaymentConfigurations.myMappings.treeItem, " +
                    "myPaymentConfigurations.myMappings.customInfo, " +
                    "myPaymentConfigurations.amountTreeItem";
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand(expand);
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelQueryConfigurations = function () {
                var expand = "myQueryConfigurations.parameters.treeItem, " +
                    "myQueryConfigurations.myDataOperation.resultSchema.properties, " +
                    "myQueryConfigurations.myDataOperation.myDataSource.objectSchemas.properties";
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand(expand);
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelCodes = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myCodeGroups.codes");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelDocumentConfiguration = function () {
                var expand = "systemDocumentConfiguration.documentTypeCodeGroup.codes, " +
                    "myDocumentConfigurations.canDownloadSecureDocumentSecurityMatrix, " +
                    "myDocumentConfigurations.canSecureDocumentSecurityMatrix, " +
                    "myDocumentConfigurations.myAvailableDocumentTypes.mySystemCode";
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevelsLazy")
                    .expand(expand);
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelStatusesAndStates = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("statusCodeGroup.myStatuses.myStates");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelClaimGroups = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myClaimGroups");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelReviewGroups = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myReviewGroups, myCodeGroups");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelSubTypeGroups = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("mySubTypeGroups");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelSystemActions = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("mySystemActions");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelFormContainerAssociations = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myFormContainerAssociations");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelTimeTrackers = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myTimeTrackers.myTimePeriods, myTimeTrackers.myClockStates, statusCodeGroup.myStatuses.myStates");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelProcessEvents = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand("myProcessEventConfigurations");
                return this.fetch(query);
            };
            SystemLevelService.prototype.getSystemLevelProcessEventConfigurations = function () {
                var expand = "myProcessEventConfigurations.myInitiateSecurityMatrix, " +
                    "myProcessEventConfigurations.myViewSecurityMatrix, " +
                    "myProcessEventConfigurations.mySystemAction, " +
                    "myProcessEventConfigurations.documentConfiguration.canDownloadSecureDocumentSecurityMatrix, " +
                    "myProcessEventConfigurations.documentConfiguration.canSecureDocumentSecurityMatrix, " +
                    "myProcessEventConfigurations.documentConfiguration.myAvailableDocumentTypes.mySystemCode";
                var query = this.breezeModule.EntityQuery
                    .from("SystemLevels")
                    .expand(expand);
                return this.fetch(query);
            };
            return SystemLevelService;
        }(services.DataService));
        services.SystemLevelService = SystemLevelService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('SystemLevelService', ['breeze', '$q']);
